// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* Double class ensures it takes precedence over the SimpleDropdown css */\n.eocIOlLApWi1aiF0gZpA.eocIOlLApWi1aiF0gZpA label {\n  min-width: 10rem;\n  width: auto;\n}\n", "",{"version":3,"sources":["webpack://./src/applab/designProperties.module.css"],"names":[],"mappings":"AAAA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,WAAW;AACb","sourcesContent":["/* Double class ensures it takes precedence over the SimpleDropdown css */\n.dropdownContainer.dropdownContainer label {\n  min-width: 10rem;\n  width: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownContainer": "eocIOlLApWi1aiF0gZpA"
};
export default ___CSS_LOADER_EXPORT___;
